module.exports = __webpack_public_path__ + "img/2022-04-25_20-06-54.5248da82.jpg";